<script>
  import {getHomepage} from "../api/homepage";

  import {Swiper, SwiperSlide} from "swiper/svelte";
  import {Navigation} from "swiper";

  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";

  import Patron from "./sub-components/Patron.svelte";
  import { UPLOADS_DIRECTORY } from "../constants";

  const getPatrons = async() => {
    const patrons = [];

    try {
      const data = await getHomepage("patrons");

      for(const patron of data) {
        patrons.push({image: `${UPLOADS_DIRECTORY}${patron.image.data.attributes.url}`, name: patron.name});
      }

      return patrons;
    } catch(error) {
      console.error(error);

      return null;
    }
  };

  const breakpoints = {
    320:  {
      slidesPerView: 1,
      spaceBetween:  25
    },
    1024: {
      slidesPerView: 1.5,
      spaceBetween:  100
    },
    1300: {
      slidesPerView: 3.25,
      spaceBetween:  100
    }
  };

  let navigation = {
    nextEl: null,
    prevEl: null
  };
</script>

<div id="anchor-patrons" class="container-fluid block m-0 m-md-5">
    <div class="row box w-100">
        <h1 class="title pt-3 text-left col-10 col-lg-8 offset-1 offset-lg-2">
            Patroni
        </h1>
        <div class="col-12">
            <div class="navigation">
                <img bind:this={navigation.prevEl} src="/images/left.svg" alt="">
                <img bind:this={navigation.nextEl} src="/images/right.svg" alt="">
            </div>
            <Swiper
                    style="padding: 1rem"
                    modules={[Navigation]}
                    {navigation}
                    {breakpoints}
                    loop
            >
                {#await getPatrons() then patrons}
                    {#if patrons}
                        {#each patrons as {image, name}}
                            <SwiperSlide>
                                <Patron {image} {name}/>
                            </SwiperSlide>
                        {/each}
                    {/if}
                {/await}
            </Swiper>
        </div>
    </div>
</div>

<style>
    .box {
        margin: 0 !important;
    }

    .block {
        padding: 0 !important;
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: auto;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }

    .navigation {
        position: absolute;
        right: 4%;
        z-index: 1000;
    }

    .navigation img {
        cursor: pointer;
    }

    .navigation img:first-of-type {
        margin-right: 1.5rem;
    }

    @media (max-width: 768px) {
        .navigation {
            display: none;
        }
    }
</style>
  